import React from 'react';
import { Award, Users, Calendar, Target } from 'lucide-react';

const AboutSection: React.FC = () => {
  return (
    <section id="about" className="py-20 bg-gradient-to-b from-dark to-black">
      <div className="container mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center max-w-7xl mx-auto">
          {/* Image Side */}
          <div className="relative order-2 lg:order-1">
            <div className="relative overflow-hidden shadow-2xl" style={{ aspectRatio: '3/4', maxHeight: '600px' }}>
              <img 
                src="/coach-ahmet.jpg"
                alt="Ahmet Ihsan Ceylan"
                className="w-full h-full object-cover"
                style={{ objectPosition: '50% 25%' }}
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent"></div>
            </div>
            
            {/* Stats Overlay */}
            <div className="absolute bottom-0 left-0 right-0 p-6 grid grid-cols-2 gap-4">
              <div className="bg-black/80 backdrop-blur-sm p-4 text-center">
                <div className="text-3xl font-bebas text-primary">2017</div>
                <div className="text-xs text-gray-400 font-montserrat">First Certified</div>
              </div>
              <div className="bg-black/80 backdrop-blur-sm p-4 text-center">
                <div className="text-3xl font-bebas text-primary">500+</div>
                <div className="text-xs text-gray-400 font-montserrat">Clients Transformed</div>
              </div>
            </div>
          </div>

          {/* Content Side */}
          <div className="order-1 lg:order-2">
            <h2 className="font-bebas text-5xl md:text-7xl text-white mb-2 tracking-wider">
              MEET THE <span className="text-primary">COACH</span>
            </h2>
            
            <h3 className="font-bebas text-3xl text-primary mb-6">
              AHMET IHSAN CEYLAN
            </h3>

            <p className="text-gray-300 font-montserrat leading-relaxed mb-6">
              Ahmet Ihsan Ceylan was first certified in 2017 and started training U15 basketball team 
              for the Netherlands. He holds a record of coaching clients ranging from complete beginners 
              to top level athletes. He likes to combine intensity with passion and class, wearing his 
              emotions openly as he streams himself into the workouts.
            </p>

            <p className="text-gray-300 font-montserrat leading-relaxed mb-8">
              He sees change as a constant part of life and draws motivation from watching it unfold - 
              with the confidence that change leads to results in no time.
            </p>

            {/* Certifications */}
            <div className="space-y-4 mb-8">
              <div className="flex items-start">
                <Award className="text-primary mr-3 mt-1 flex-shrink-0" size={20} />
                <div>
                  <h4 className="text-white font-montserrat font-semibold">NASM Certified Personal Trainer</h4>
                  <p className="text-gray-400 text-sm font-montserrat">National Academy of Sports Medicine</p>
                </div>
              </div>
              
              <div className="flex items-start">
                <Award className="text-primary mr-3 mt-1 flex-shrink-0" size={20} />
                <div>
                  <h4 className="text-white font-montserrat font-semibold">NASM Performance Enhancement Specialist</h4>
                  <p className="text-gray-400 text-sm font-montserrat">National Academy of Sports Medicine</p>
                </div>
              </div>
            </div>

            {/* Quick Stats */}
            <div className="grid grid-cols-3 gap-4">
              <div className="text-center">
                <Calendar className="text-primary mx-auto mb-2" size={24} />
                <div className="text-white font-bebas text-xl">7+ YEARS</div>
                <div className="text-gray-400 text-xs font-montserrat">Experience</div>
              </div>
              <div className="text-center">
                <Users className="text-primary mx-auto mb-2" size={24} />
                <div className="text-white font-bebas text-xl">ALL LEVELS</div>
                <div className="text-gray-400 text-xs font-montserrat">Welcome</div>
              </div>
              <div className="text-center">
                <Target className="text-primary mx-auto mb-2" size={24} />
                <div className="text-white font-bebas text-xl">RESULTS</div>
                <div className="text-gray-400 text-xs font-montserrat">Guaranteed</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;